import { render, staticRenderFns } from "./23.vue?vue&type=template&id=fdd467ba&scoped=true&"
import script from "./23.vue?vue&type=script&lang=js&"
export * from "./23.vue?vue&type=script&lang=js&"
import style0 from "./23.vue?vue&type=style&index=0&id=fdd467ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd467ba",
  null
  
)

export default component.exports